import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { AdminTableconstant } from "./AdminTableConstant";

const initialState = {
  AdminTableList: [{}],
  AdminTable: {
    isLoading: false,
  },
};

export const AdminTableReducer = persistReducer(
  {
    storage,
    key: "AdminTable",
    whitelist: [" AdminTableList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case AdminTableconstant.ADMIN_TABLE_REQUEST: {
        return {
          ...state,
          AdminTableList: [{}],
          AdminTable: {
            isLoading: true,
          },
        };
      }

      case AdminTableconstant.ADMIN_TABLE_RESPONSE: {
        return {
          ...state,
          AdminTableList: payload,
          AdminTable: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
